// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_pj-8";
export var editMode = "_pj-3";
export var headerRow = "_pj-a";
export var headerTitle = "_pj-b";
export var product = "_pj-1";
export var productDetails = "_pj-5";
export var productDivider = "_pj-7";
export var productImage = "_pj-2";
export var productInfo = "_pj-4";
export var productTitle = "_pj-6";
export var strikethrough = "_pj-9";
export var upsellProductsCard = "_pj-0";